import React, { useEffect, useMemo } from 'react';
import HomeHero from '../components/mk/home/HomeHero';
import HomeProof from '../components/mk/home/HomeProof';
import HomeHow from '../components/mk/home/HomeHow';
import HomeBento from '../components/mk/home/HomeBento';
import HomeReviews from '../components/mk/home/HomeReviews';
import HomeFounder from '../components/mk/home/HomeFounder';
import HomeBmb from '../components/mk/home/HomeBmb';
import HomeCompare from '../components/mk/home/HomeCompare';
import HomeTrust from '../components/mk/home/HomeTrust';
import HomeFaq from '../components/mk/home/HomeFaq';
import HomeFinal from '../components/mk/home/HomeFinal';
import MkStickyCta from '../components/mk/MkStickyCta';
import { detectPlatform } from '../marketing/links';
import { mkTrack } from '../marketing/track';

// keepmeout.app/ — Keep Me Out first, proof above the fold, Bring Me Back as its companion.
// `platform` is computed during render so every platform branch exists when ScrollReveal inits.
const Home = ({ platform: forced }) => {
  const platform = useMemo(() => forced || detectPlatform(), [forced]);
  useEffect(() => {
    mkTrack('platform_view', `${platform}:home`, { nonInteraction: true });
  }, [platform]);
  return (
    <>
      <div className="mk-page mk-home">
        <HomeHero platform={platform} />
        <HomeProof />
        <HomeHow platform={platform} />
        <HomeBento platform={platform} />
        <HomeReviews platform={platform} />
        <HomeFounder platform={platform} />
        <HomeBmb platform={platform} />
        <HomeCompare platform={platform} />
        <HomeTrust />
        <HomeFaq />
        <HomeFinal platform={platform} />
      </div>
      <MkStickyCta app="kmo" platform={platform} page="home" />
    </>
  );
};

export default Home;
